var map = {
	"./1.png": 7308,
	"./10.png": 5803,
	"./11.png": 5202,
	"./2.png": 5082,
	"./3.png": 4926,
	"./4.png": 5272,
	"./5.png": 264,
	"./6.png": 2059,
	"./7.png": 4681,
	"./8.png": 347,
	"./9.png": 8200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5236;